import { Api } from '@/api';
import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { computed, ref } from 'vue';
import { toast } from 'vue-sonner';
import { validateWorkflow } from '../../workflowValidator';

export const useTitleBar = () => {
  const currentWorkflowStore = useCurrentWorkflowStore();

  const editMode = ref(false);
  const inputName = ref(currentWorkflowStore.currentWorkflow.name);
  const inputDescription = ref(currentWorkflowStore.currentWorkflow.description);

  const updateNameAndDescription = async () => {
    const errors = validateWorkflow({ name: inputName.value, description: inputDescription.value });
    if (errors.length > 0) {
      const description = `${errors.join(', ')}.`;
      toast.error('Workflow Update Error', { description });
      return;
    }
    const response = await Api.Workflows.updateWorkflow({
      workflowId: currentWorkflowStore.currentWorkflow.id,
      params: { name: inputName.value, description: inputDescription.value },
    });
    if (response.status === 'success') {
      const description = 'Your workflow was successfully updated.';
      toast.success('Workflow Updated', { description });
      editMode.value = false;
      currentWorkflowStore.update({ name: inputName.value, description: inputDescription.value });
    } else {
      const description = `${response.messages.join(', ')}.`;
      toast.error('Workflow Update Error', { description });
    }
  };

  const hasActions = computed(() => currentWorkflowStore.currentWorkflow.workflow_actions.length > 0);

  return {
    editMode,
    inputName,
    inputDescription,
    hasActions,
    enableEditMode: () => (editMode.value = true),
    disableEditMode: () => (editMode.value = false),
    updateNameAndDescription,
  };
};
